import { directoryLogoPath, defaultLogoPath, mapBrands } from './BrandMapping'

const classNameJobTile: string = 'attrax-vacancy-tile'
    const classNameContainerLogo: string = `${classNameJobTile}__container-logo`
    const classNameContainerDetails: string = `${classNameJobTile}__container-details`
    const classNameOptionBrand: string = `${classNameJobTile}__option-brand`
    const classNameDetails: Array<string> = [
        `${classNameJobTile}__description`,
        `${classNameJobTile}__salary`,
        `${classNameJobTile}__reference`,
        `${classNameJobTile}__expiry`,
        `${classNameJobTile}__location-freetext`,
        `${classNameJobTile}__option-department`,
        `${classNameJobTile}__option-job-type`,
        `${classNameJobTile}__option-location`,
        `${classNameJobTile}__option-brand`,
    ]

export const initialise = () => {
    const jobTiles: NodeListOf<HTMLDivElement> = document.querySelectorAll(`.${classNameJobTile}`)
    if (!jobTiles) return

    logoContainer(jobTiles)
    moveDetails(jobTiles)
    updateLogo()
}

const logoContainer = (jobTiles: NodeListOf<HTMLDivElement>) => {
    jobTiles.forEach((jobTile: HTMLDivElement) => {
        let container: HTMLDivElement = document.createElement('div')
        container.classList.add(classNameContainerLogo)
        jobTile.prepend(container)

        let logo: HTMLImageElement = document.createElement('img')
        logo.alt = ''
        logo.width = 180
        logo.height = 40
        logo.loading = 'lazy'
        logo.src = defaultLogoPath
        container.appendChild(logo)
    })
}

const moveDetails = (jobTiles: NodeListOf<HTMLDivElement>) => {
    jobTiles.forEach((jobTile: HTMLDivElement) => {
        let container: HTMLDivElement = document.createElement('div')
        container.classList.add(classNameContainerDetails)
        jobTile.appendChild(container)

        const detailsSelector: string = classNameDetails.map(className => `.${className}`).join(', ')
        const details = jobTile.querySelectorAll(detailsSelector)
        details.forEach((detail: HTMLElement) => {
            container.appendChild(detail)
        })
    })
}

const updateLogo = () => {
    mapBrands.forEach((fileType: string, fileName: string) => {
        const classNameBrand: string = `.${classNameOptionBrand}--${fileName}`

        if (document.getElementsByClassName(classNameBrand)) {
            let brandFileName: string = `${fileName}.${fileType}`
            const filePath: string = `${directoryLogoPath}/${brandFileName}`
            const brandOptions: NodeListOf<HTMLElement> = document.querySelectorAll(classNameBrand)

            brandOptions.forEach((brandOption: HTMLElement) => {
                const jobTile = brandOption.closest<HTMLElement>(`.${classNameJobTile}`)
                if (!jobTile) return
                const container = jobTile.querySelector<HTMLElement>(`.${classNameContainerLogo}`)
                if (!container) return
                const logo = container.querySelector<HTMLImageElement>('img')
                if (!logo) return
                logo.src = filePath
            })
        }
    })
}